import Image from 'next/image';

import * as PS from '../style';
import type { GridCard, GridCardsDiv } from '../type';
import { isValidUrl } from './logic';
import * as S from './style';

export default function GridCardsDivFrame({ div }: { div: GridCardsDiv }) {
  const mobileColumnNumber = div.colNumber.mobile;
  const desktopColumnNumber = div.colNumber.desktop;

  function handleImageClick(card: GridCard) {
    if (!isValidUrl(card.url)) {
      return;
    }

    card.isNewTab
      ? window.open(card.url, '_blank')
      : (window.location.href = card.url);
  }

  return (
    <PS.DivWrapper id={div.tagId} bgColor={div.bgColor}>
      <S.MobileWrapper columns={mobileColumnNumber}>
        {div.cards.map((card, index) => (
          <S.ImageWrapper
            key={`card_${index}`}
            onClick={() => handleImageClick(card)}
          >
            {card.mobileImageUrl && (
              <Image
                key={`card_${index}`}
                src={card.mobileImageUrl}
                alt='test'
                fill
                priority
                sizes='100%'
              />
            )}
          </S.ImageWrapper>
        ))}
      </S.MobileWrapper>
      <S.DesktopWrapper columns={desktopColumnNumber}>
        {div.cards.map((card, index) => (
          <S.ImageWrapper
            key={`card_${index}`}
            onClick={() => handleImageClick(card)}
          >
            {card.desktopImageUrl && (
              <Image
                src={card.mobileImageUrl}
                alt='test'
                fill
                priority
                sizes='100%'
              />
            )}
          </S.ImageWrapper>
        ))}
      </S.DesktopWrapper>
    </PS.DivWrapper>
  );
}
